import React from "react";
import GenerateSkeletonHolder from "../../styles/generateSkeletonStyle";

const GenerateSkeleton = ({ height = 400 }) => (
  <GenerateSkeletonHolder height={height}>
    <div className="graph-skeleton-container">
      <div className="y-axis">
        {[0, 1, 2, 3].map((_, index) => (
          <div key={index} className="y-axis-mark" />
        ))}
      </div>
      <div className="x-axis" />
      <div className="bars-container">
        {Array.from({ length: 7 }).map((_, index) => (
          <div
            key={index}
            className="skeleton-bar"
            style={{ height: `${Math.random() * 60 + 20}%` }}
          />
        ))}
      </div>
    </div>
  </GenerateSkeletonHolder>
);

export default GenerateSkeleton;
